@if (!isLoading) {
<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
}
